export const NetworkPatterns = {
    // PanL Network ID: prefix 'PN0' followed by 24 alphanumeric characters
    panlNetworkIdPattern: /^(PN0[a-zA-Z0-9]{24}$)/,
} as const;

// Breadcrumb labels mapping
export const BREADCRUMB_LABELS: Record<string, string> = {
    networks: "All Networks",
    "network-details": "Network Details",
    zone: "Zone",
    "room-details": "Room",
    "group-details": "Group",
    "hub-details": "Hub",
    controller: "Actuator",
    "controller-details": "Actuator",
    sensor: "Sensor",
    "sensor-details": "Sensor",
    group: "Group",
    "auxiliary-hub": "Auxiliary Hub",
    "auxiliary-hub-details": "Auxiliary Hub",
} as const;

// Default values for controller details
export const DEFAULT_VALUES = {
    HUB_NAME: "-",
    HUB_PORT: "-",
    ROOM_MEMBERSHIP: "-",
    NETWORK_NAME: "-",
    CONTROLLER_TYPE: "-",
    CONTROLLER_NAME: "-",
    CONTROLLER_ID: "-",
    NEVER: "Never",
    UNKNOWN: "Unknown"
} as const;

// Style constants for controller details
export const STYLE_CONSTANTS = {
    PANEL_BACKGROUND: '#2f3a51',
    PANEL_BORDER_RADIUS: '8px',
    PANEL_PADDING: '24px',
    PANEL_MARGIN_BOTTOM: '20px',
    ERROR_COLOR: '#ff3860',
    TEXT_COLOR_SECONDARY: '#828fab',
    FORM_BOX_PADDING: '30px',
    FORM_BOX_PADDING_TOP_BOTTOM: '0.5rem'
} as const;

// Bus configuration constants
export const BUS_COUNT = 3;
export const DEFAULT_BUS_NUMBER = "1";


